import React from "react";
import PolicyPage from "./PolicyPage";
import { STORE } from "../config/store";

const sections = [
  {
    title: "Currency and calculation",
    paragraphs: [`Every product price, basket subtotal and payment request uses ${STORE.currency}. Checkout multiplies each selected price by its quantity, adds the lines, then adds the fixed ${STORE.currency} ${STORE.shippingFee.toFixed(2)} delivery charge once. The final total is shown before Pay Now.`],
  },
  {
    title: "Hosted card entry",
    paragraphs: ["Pay Now opens the same-origin payment endpoint, which creates a hosted checkout session. Card number, expiry date and security code are entered only on that hosted screen. They must never be typed into the delivery form or sent to customer service."],
  },
  {
    title: "Order reference and return pages",
    paragraphs: ["Each payment attempt carries a newly generated order reference plus the total, currency, purchaser email, first-item title and return links. A browser arriving at a success return page does not prove that funds settled. Fulfilment starts only after the order is matched to independent payment confirmation."],
  },
  {
    title: "Pricing errors",
    paragraphs: ["The displayed product record and computed basket should agree. If an obvious publication or arithmetic error is found before acceptance, the correct figure is explained and the customer can proceed on that basis or close the attempt. An increase is not imposed silently and payment is not captured for a replacement total without agreement."],
  },
  {
    title: "Security review",
    paragraphs: ["Verification may halt an attempt if independent confirmation is absent, destination entries conflict or remain incomplete, activity indicates unauthorised use, or selected inventory cannot be established. Any follow-up is limited to facts needed to match purchaser, order and recipient. Full card credentials are never requested in a message."],
  },
  {
    title: "Refund route and disputes",
    paragraphs: ["Where the original payment route supports refunds, an approved amount is initiated back to that route; its operator controls the later account posting. Supplying the order reference and precise concern first allows the store to compare transaction records before a formal payment dispute. This review does not waive a right available to the customer."],
  },
];

export default function PaymentPolicy() {
  return <PolicyPage title="Payment, Pricing & Fraud Policy" intro="How the HKD total reaches hosted card checkout and how order verification protects the transaction." sections={sections} related={[["Terms of Sale", "/terms-of-sale"], ["Discounts & Promotions", "/discounts-promotions"], ["Order Cancellation", "/order-cancellation"]]} />;
}
